import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const GET_CLIENT_REQUEST = "client/GET_CLIENT_REQUEST";
export const GET_CLIENT_SUCCESS = "client/GET_CLIENT_SUCCESS";

export const GET_USERS_REQUEST = "client/GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "client/GET_USERS_SUCCESS";

export const GET_HOME_TP_LIST_REQUEST = "client/GET_HOME_TP_LIST";
export const GET_HOME_TP_LIST_SUCCESS = "client/GET_HOME_TP_LIST_SUCCESS";
export const GET_ALLBRANDTOUCHPOINT_REQUEST = "client/GET_ALLBRANDTOUCHPOINT_REQUEST";
export const GET_ALLBRANDTOUCHPOINT_SUCCESS = "client/GET_ALLBRANDTOUCHPOINT_SUCCESS";

export const SET_CLIENT_FROM_HASH = "client/SET_CLIENT_FROM_HASH";

export const clientActions = {
  getClient: createPromiseAction(GET_CLIENT_REQUEST),
  getClientSuccess: createAction(GET_CLIENT_SUCCESS),
  getUsers: createPromiseAction(GET_USERS_REQUEST),
  getUsersSuccess: createAction(GET_USERS_SUCCESS),
  getHomePageTPlist: createPromiseAction(GET_HOME_TP_LIST_REQUEST),
  getHomePageTPlistSuccess: createAction(GET_HOME_TP_LIST_SUCCESS),
  getAllBrandTouchPoint: createPromiseAction(GET_ALLBRANDTOUCHPOINT_REQUEST),
  getAllBrandTouchPointSuccess: createAction(GET_ALLBRANDTOUCHPOINT_SUCCESS),
  setClientFromUserHash: createAction(SET_CLIENT_FROM_HASH),
};
